import React from 'react';
import { InspectionChecklistItem } from '../../types/inspection';
import { CheckSquare, Square } from 'lucide-react';

interface InspectionChecklistProps {
  items: InspectionChecklistItem[];
  onChange?: (items: InspectionChecklistItem[]) => void;
  readonly?: boolean;
}

export const InspectionChecklist: React.FC<InspectionChecklistProps> = ({
  items,
  onChange,
  readonly = false,
}) => {
  const handleToggle = (itemId: string) => {
    if (readonly || !onChange) return;
    onChange(items.map(item =>
      item.item_id === itemId ? { ...item, checked: !item.checked } : item
    ));
  };

  const checkedCount = items.filter(i => i.checked).length;
  const allChecked = items.length > 0 && checkedCount === items.length;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between mb-2">
        <p className="text-xs font-semibold text-slate-300">Inspection Checklist</p>
        <span className={`text-xs font-mono ${allChecked ? 'text-emerald-400' : 'text-slate-400'}`}>
          {checkedCount}/{items.length}
        </span>
      </div>
      {items.map(item => (
        <button
          key={item.item_id}
          type="button"
          disabled={readonly}
          onClick={() => handleToggle(item.item_id)}
          className={`flex items-center gap-3 w-full p-2.5 rounded-lg text-left text-sm transition-colors ${
            readonly
              ? 'bg-slate-950 border border-slate-800'
              : 'bg-slate-950 border border-slate-800 hover:border-sky-500/50 cursor-pointer'
          }`}
        >
          {item.checked ? (
            <CheckSquare className="w-4 h-4 text-emerald-400 flex-shrink-0" />
          ) : (
            <Square className="w-4 h-4 text-slate-500 flex-shrink-0" />
          )}
          <span className={`text-xs ${item.checked ? 'text-slate-300' : 'text-slate-400'}`}>
            {item.label}
          </span>
        </button>
      ))}
    </div>
  );
};
